import { appGetState } from 'legacy/lut/store'

import { IDataProviderFilter, IDataProviderSort, Logic, Operator } from 'core-components/types'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpCancel, HttpHeaders, HttpRequest } from 'core/classes/http'
import { MarketApi } from 'core/classes/services/api/MarketApi'
import { CrudHelper } from 'core/types/helpers/CrudHelper'

export interface IBusinessProfileIcon {
  Id?: string
  Class?: string
  Color?: string
  Hint?: string
  Name?: string
  Default?: boolean
}

const headers = new HttpHeaders()
headers.add('Content-Type', 'application/json; charset=UTF-8')

const request = new HttpRequest(headers)

class BusinessProfileApi {
  public fetchStaticData = async (cancelObject: HttpCancel) => {
    const url = proxy('/form/view/1284')
    const rows: IObjectAny[] = await request.get({ url, cancelObject })
    const { data }: any = rows || {}
    return data || {}
  }

  public fetchCountriesCode = async (cancelObject: HttpCancel) => {
    const region = MarketApi.getRegion(appGetState().user.geoMarket).Region
    const crud = new CrudHelper(74, 'CountriesList')
    const sort: IDataProviderSort = {
      field: 'PhoneCode',
      dir: 'desc',
    }
    const filter: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [
        {
          field: 'RegionL0',
          value: region,
          operator: Operator.EQUAL,
        },
      ],
    }
    const response =
      (await crud.read(filter, sort, undefined, undefined, cancelObject, undefined, true)) || {}
    const result: any = {}
    if (response && response['Data']) {
      response['Data'].forEach((element: any) => {
        if (!result[element.PhoneCode]) {
          result[element.PhoneCode] = [element.CC]
        } else {
          result[element.PhoneCode].push(element.CC)
        }
      })
    }
    return [{ EntryID: 1, codes: result }]
  }

  public fetchRegDashboardReal = async (contactIds: Set<string>, cancelObject: HttpCancel) => {
    const crudHelper = new CrudHelper(261, 'Reg_Dashboard_Real')
    const filter: IDataProviderFilter = {
      logic: Logic.OR,
      filters: [],
    }

    if (contactIds.size) {
      contactIds.forEach(
        (contactId) =>
          (filter.filters[filter.filters.length] = {
            field: 'ContactID',
            operator: Operator.EQUAL,
            value: contactId,
          })
      )
    }

    if (contactIds.size) {
      const sort: IDataProviderSort = { field: 'EntryID', dir: 'desc' }
      const response = await crudHelper.read(
        filter,
        sort,
        undefined,
        undefined,
        cancelObject,
        undefined,
        true
      )
      return response['Data'] || []
    }

    return []
  }
}

export default new BusinessProfileApi()
